var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00E2A4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_196343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1812 13.7746C22.0929 12.6881 20.5077 12.5316 19.0161 12.4947C18.3313 12.4763 17.7471 12.4671 17.1628 12.4671C16.5785 12.4671 15.9943 12.4763 15.3095 12.4947C13.8273 12.5316 12.2326 12.6881 11.1445 13.7746C10.0188 14.9074 10.0282 16.7491 10 18.2042V21.8049C10.0282 23.26 10.0188 25.1017 11.1445 26.2252C12.2326 27.3117 13.818 27.4684 15.3095 27.5051C15.9943 27.5235 16.5785 27.5328 17.1628 27.5328C17.7471 27.5328 18.3313 27.5235 19.0161 27.5051C20.4982 27.4684 22.0929 27.3117 23.1812 26.2252C24.3067 25.1017 24.2975 23.26 24.3255 21.8049C24.335 21.2063 24.3443 20.5985 24.335 20C24.335 19.4015 24.335 18.8029 24.3255 18.1951C24.2974 16.74 24.3067 14.8982 23.1812 13.7746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 15.1403C28.6476 15.1403 28.4501 15.1947 28.2637 15.3141L24.882 17.4806V22.5193L28.2637 24.6856C28.4501 24.805 28.6478 24.8596 28.8404 24.8596C29.4445 24.8596 29.9987 24.3235 29.9987 23.5742V16.4258C29.9987 15.6767 29.4443 15.1403 28.8402 15.1403Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_196343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoa);
export default __webpack_public_path__ + "static/media/videoa.9a532603a2528338b6c92806a85ca29d.svg";
export { ForwardRef as ReactComponent };